import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import shadows from 'theme/atoms/shadows';

interface ToolbarButtonProps {
  active?: boolean;
}

// Header Section
export const Toolbar = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 5px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 5;
`;

export const ToolbarButton = styled('div')<ToolbarButtonProps>`
  align-items: center;
  background-color: white;
  border: 0.5px solid ${colours.neutral[200]};
  border-radius: 30px;
  box-shadow: ${shadows.XS};
  color: ${(props) =>
    props.active ? colours.primary[500] : colours.neutral[500]};
  cursor: ${(props) => !props.active && 'pointer'};
  display: flex;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  gap: 5px;
  line-height: 18px;
  max-height: 44px;
  padding: 10px;
  pointer-events: ${(props) => props.active && 'none'};
  user-select: none;
  width: fit-content;

  svg {
    height: 15;
    width: 15;
    stroke-width: 2;
  }

  svg path {
    stroke: ${(props) =>
      props.active ? colours.primary[500] : colours.neutral[500]};
  }

  &:hover {
    color: ${(props) => !props.active && 'black'};
    border: ${(props) =>
      !props.active && `0.5px solid ${colours.neutral[500]};`};

    svg path {
      stroke: ${(props) => (props.active ? colours.primary[500] : 'black')};
    }
  }

  &:focus {
    color: ${(props) => !props.active && 'black'};
    border: ${(props) =>
      !props.active && `0.5px solid ${colours.neutral[500]};`};
  }

  &:active {
    color: ${(props) => !props.active && 'black'};
    border: ${(props) =>
      !props.active && `0.5px solid ${colours.neutral[500]};`};
  }
`;
